import React from 'react';

const TILES = [
    { type: 'M1', label: 'M1', color: '#34d399', bg: 'rgba(52, 211, 153, 0.15)' },
    { type: 'M2', label: 'M2', color: '#ec4899', bg: 'rgba(236, 72, 153, 0.15)' },
    { type: 'M3', label: 'M3 (GIS)', color: '#fbbf24', bg: 'rgba(251, 191, 36, 0.15)' },
    { type: 'M4', label: 'M4 (TX)', color: '#60a5fa', bg: 'rgba(96, 165, 250, 0.15)' },
];

export default function ModulePalette({ onDragStart, activeType, tiles }) {
    const visibleTiles = tiles || TILES;
    return (
        <div className="sp-module-palette">
            <div className="sp-module-palette-title">Place Modules</div>
            <div className="sp-module-palette-tiles">
                {visibleTiles.map(({ type, label, color, bg }) => (
                    <button
                        key={type}
                        type="button"
                        className={`sp-module-tile${activeType === type ? ' dragging' : ''}`}
                        style={{ borderColor: color, background: bg }}
                        onMouseDown={(e) => {
                            e.preventDefault();
                            onDragStart(type);
                        }}
                        onTouchStart={(e) => {
                            e.preventDefault();
                            onDragStart(type);
                        }}
                        title={`Drag ${label} onto the layout`}
                    >
                        <span className="sp-module-tile-label" style={{ color }}>
                            {label}
                        </span>
                    </button>
                ))}
            </div>
            <div className="sp-module-palette-hint">
                Drag onto usable area · Right-click to rotate when selected
            </div>
        </div>
    );
}
